import { I18n } from '@calendly/i18n';
import { ArrowExpandIcon } from '@calendly/ui/components/icons';
import { Link } from '@calendly/ui/components/link';
import { colorIconSecondary } from '@calendly/ui/theme';
import { CALLIE_LEARN_MORE_HELP_URL } from 'components/home/ai_assistant_banner/constants';
const linkLabelCss = "ltl3a3r";
export const CallieFooterLink = () => <div data-testid="callie-footer-link">
    <Link href={CALLIE_LEARN_MORE_HELP_URL} rel="noopener noreferrer" target="_blank">
      <span className={linkLabelCss}>
        {I18n.t('publisher.home.scheduling_subsection.callie.footer_link')}
        <ArrowExpandIcon color={colorIconSecondary} aria-hidden />
      </span>
    </Link>
  </div>;

require("./callie_footer_link.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./callie_footer_link.js");